export const getSpecFilterValueProp = inputType => {
  let valueProp = 'value'

  if (inputType === 'multiselect') valueProp = 'values'
  if (['selectRange', 'inputRange'].includes(inputType)) valueProp = 'range'

  return valueProp
}
